/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateInventoryCommandResult } from '../../models/update-inventory-command-result';

export interface ApiNurseryManagerInventoryUpdateInventoryPost$Params {
      body?: {
'ItemId'?: string;
'StoreId'?: string;
'Quantity'?: number;
'ReceiverId'?: string;
'SupervisorId'?: string;
}
}

export function apiNurseryManagerInventoryUpdateInventoryPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryUpdateInventoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateInventoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryUpdateInventoryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateInventoryCommandResult>;
    })
  );
}

apiNurseryManagerInventoryUpdateInventoryPost.PATH = '/api/NurseryManager/Inventory/UpdateInventory';
